module.exports = { "default": require("core-js/library/fn/array/from"), __esModule: true };


//////////////////
// WEBPACK FOOTER
// ../js/~/babel-runtime/core-js/array/from.js
// module id = 609
// module chunks = 0